import { generalConstants } from "@/utils/constants";
import { reportError } from "../errorHelper";
import { client } from "@/utils/netlify";

export const getShopifyTagData = (tags) => {
  if (tags) {
    const tagData = {
      categories_lvl2: [],
      categories_lvl1: [],
      categories_lvl0: [],
      final_sale: false,
      mto: false,    //define mto tag as false initially
      engrave: false
    };

    tags.forEach((tag) => {
      if (tag.startsWith("categories.lvl2")) {
        let categories = tag.replace("categories.lvl2:", "").split(" > ");
        tagData.categories_lvl2.push(categories);
      } else if (tag.startsWith("categories.lvl1")) {
        let categories = tag.replace("categories.lvl1:", "").split(" > ");
        tagData.categories_lvl1.push(categories);
      } else if (tag.startsWith("categories.lvl0")) {
        let category = tag.replace("categories.lvl0:", "");
        tagData.categories_lvl0.push(category);
      }

      if (tag === "Final sale") {
        tagData.final_sale = true;
      }
    //If the shopify tags contains MTO tag then assign it as true
      if (tag === "MTO") {
        tagData.mto = true;
      }
      if(tag === "Tag2:ENGRAVING AVAILABLE") {
        tagData.engrave = true
      }
    });

    return tagData;
  }
  return null;
};

// OS-91 - Size Guide
export const getSizeGuideType = (tagData, sizes) => {
  
  //display size guide even for one size products
  if (tagData) {
    let level1CategoriesNecklace = [...tagData.categories_lvl1,...tagData.categories_lvl2];

     //Necklaces
     if (
      level1CategoriesNecklace.some((categories) => {
        return categories.some((category) => category === "Necklaces");
      })
    ) {
      return "Necklaces";
    }
  }


  if (tagData && sizes) {
    // Do not display size guide for one size products
    if (sizes.length === 1 && sizes[0].toLowerCase() === generalConstants.one_size) {
      return false;
    }

    const level1Categories = tagData.categories_lvl1;

    //rings
    if (
      level1Categories.some((categories) => {
        return categories.some((category) => category === "Rings");
      })
    ) {
      return "Rings";
    }
    // First check jeans
    if (
      level1Categories.some((categories) => {
        return categories.some((category) => category === "Jeans");
      })
    ) {
      return "jeans";
    }

    const level0Categories = tagData.categories_lvl0;
    // Check clothing
    if (
      level0Categories.some((category) => {
        return category === "Clothing";
      })
    ) {
      return "clothing";
    }

    // Check shoes
    if (
      level0Categories.some((category) => {
        return category === "Shoes";
      })
    ) {
      return "shoes";
    }
  }

  return null;
};


//OS-2035
export const sortSizes=(sizeData)=>{
  if(sizeData && Array.isArray(sizeData)){
    if(/\d/.test(sizeData[0])){
      sizeData.sort((a, b) => {
        let f = parseFloat(a);
        let s = parseFloat(b);
        if (f < s) return -1;
        else return 1;
    })
    }else{
      let weights =generalConstants.size_weights;
      sizeData.sort(
        (a, b) => weights[a] - weights[b]
        )
    }
  }
}

//fetch brand details
export const getBrandDetails = async (brand) => {
  try {
    const res = await client("get-brand-details", { brand });
    return res
  } catch(err) {
    reportError("Error fetching vendor logo");
  }
}